import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class SessionService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Get session
     * Returns information about current session.
     * @returns Session OK.
     * @throws ApiError
     */
    getSession(options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/session', errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get session request
     * @returns any ok.
     * @throws ApiError
     */
    authorize({ returnUrl, deviceLoginId, clientId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/session/authorize', query: {
                'returnUrl': returnUrl,
                'deviceLoginId': deviceLoginId,
                'clientId': clientId,
            }, errors: {
                302: `Redirects to login page.`,
                400: `Bad Request.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete active user session
     * @returns any ok.
     * @throws ApiError
     */
    revoke({ returnUrl, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/session/revoke', query: {
                'returnUrl': returnUrl,
            }, errors: {
                302: `Redirects to login page.`,
                400: `Bad Request.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update access token expiration time
     * @returns SessionToken Returns refresh token for extended session.
     * @throws ApiError
     */
    refresh({ requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/session/refresh', body: requestBody, mediaType: 'application/json', errors: {
                401: `User is not authorized to access this resource.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=SessionService.js.map